var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React, { useContext, useEffect, useState } from 'react';
import { Grid } from '@material-ui/core';
import { Controller } from 'react-hook-form';
import glue, { ReactTranslationContext, TranslationContext } from "../../../../index";
import { LanguageSelector } from "../../../../../components/LanguageSelector";
export const node = 1;
export const TranslatableControl = (_a) => {
    var { rules, render, localTranslation = false, name, control, style = {} } = _a, props = __rest(_a, ["rules", "render", "localTranslation", "name", "control", "style"]);
    const parentTranslation = useContext(ReactTranslationContext);
    const [localTranslationContext, setLocalTranslationContext] = useState(null);
    useEffect(() => {
        if (localTranslation && localTranslationContext === null) {
            if (parentTranslation) {
                setLocalTranslationContext(new TranslationContext(parentTranslation.language, parentTranslation.languages[0], parentTranslation.languages, setLocalTranslationContext));
            }
            else {
                setLocalTranslationContext(new TranslationContext(undefined, glue.editingAvailableLanguages[0], glue.editingAvailableLanguages, setLocalTranslationContext));
            }
        }
    }, [localTranslation, parentTranslation, localTranslationContext]);
    const translation = localTranslation ? localTranslationContext : parentTranslation;
    if (translation === null) {
        return React.createElement(Controller, Object.assign({ key: name }, props, { name: name, control: control, render: render }));
    }
    const fields = translation === null || translation === void 0 ? void 0 : translation.languages.map((code, index) => {
        let fieldName = name;
        if (index > 0) {
            fieldName = `__translation.${index - 1}.${code}.${name}`;
        }
        return React.createElement(Grid, { key: index, item: true, style: (translation === null || translation === void 0 ? void 0 : translation.language) === code ? Object.assign({}, style) : Object.assign(Object.assign({}, style), { visibility: 'hidden', position: 'absolute' }), xs: 12 },
            React.createElement(Controller, Object.assign({ key: fieldName }, props, { name: fieldName, control: control, render: render, rules: Object.assign(Object.assign({}, rules), { required: !!((rules === null || rules === void 0 ? void 0 : rules.required) && index === 0) }) })));
    });
    if (localTranslation) {
        return React.createElement(Grid, { container: true, spacing: 1, alignItems: "flex-end" },
            React.createElement(ReactTranslationContext.Provider, { value: localTranslationContext },
                React.createElement(Grid, { item: true, xs: 10 },
                    React.createElement(Grid, { container: true }, fields)),
                React.createElement(Grid, { item: true, xs: 2 },
                    React.createElement(LanguageSelector, Object.assign({}, { showSelectedLabel: false, showOptionLabel: false })))));
    }
    return React.createElement(Grid, { container: true }, fields);
};
//# sourceMappingURL=index.js.map